import { auth, waitForFirebaseAuth } from "../config/firebase.config";
import { clearAppStorage } from '../utils/storageUtils';

const isLoginPage = () => {
  return window.location.pathname === '/login' || 
         window.location.pathname === '/signup' ||
         window.location.pathname === '/reset';
};

const handleAuthFailure = async () => {
  if (isLoginPage()) return;
  
  try {
    await auth.signOut();
  } catch (e) {
    console.error("Error signing out:", e);
  }
  clearAppStorage();
  window.location.href = '/login';
};

export const getValidToken = async (forceRefresh = false) => {
  const user = await waitForFirebaseAuth();
  
  if (user) {
    try {
      const token = await user.getIdToken(forceRefresh);
      localStorage.setItem("token", token);
      localStorage.setItem("isLoggedIn", "true");
      return token;
    } catch (error) {
      console.error("AuthUtils: Token error:", error);
      if (error.code === 'auth/user-token-expired' || 
          error.message?.includes('invalid-authentication-credentials') ||
          error.message?.includes('auth/invalid-refresh-token') ||
          error.message?.includes('auth/user-disabled')) {
        await handleAuthFailure();
      }
      return null;
    }
  }
  
  const storedToken = localStorage.getItem("token");
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  
  if (storedToken && isLoggedIn) {
    console.log("AuthUtils: Firebase not ready, using cached token (backend will validate)");
    return storedToken;
  }
  
  return null;
};

export const refreshAuthToken = async (force = false) => {
  return getValidToken(force);
};

export const isAuthenticated = async () => {
  const user = await waitForFirebaseAuth();
  return !!user;
};
